import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { EnergyConsumptionReportConfiguration, EnergyConsumptionReportConfigurationService } from "../../../../services/energy-consumption-report-configuration.service";

@Component({
    selector: "energy-consumption-report-configuration-form",
    templateUrl: "./energy-consumption-report-configuration-form.component.html",
    styleUrls: ["../../../../style/azdatafactory.component.less", "../../../../style/custom-mat-dialog.component.less"],
    standalone: false
})
export class EnergyConsumptionReportConfigurationFormComponent implements OnInit {
    controllerTypes: ControllerType[] = [];
    isEditing = false;
    readonly form: FormGroup;

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly configurationService: EnergyConsumptionReportConfigurationService,
        public readonly dialogRef: MatDialogRef<EnergyConsumptionReportConfigurationFormComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: EnergyConsumptionReportConfiguration
    ) {
        this.form = this.formBuilder.group({
            controllerType: ["", Validators.required],
            enable: [false],
            sendInterval: ["", [Validators.required, Validators.pattern(/^(daily|hourly|direct)$/)]],
            reportingInterval: [15, [Validators.required, Validators.pattern(/^(15|60)$/)]]
        });
    }

    ngOnInit(): void {
        this.isEditing = !!this.data.controllerType;
        this.form.patchValue(this.data);
        this.configurationService.getControllerTypes().subscribe({
            next: controllerTypes => this.controllerTypes = controllerTypes,
            error: () => { }
        });
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onSubmit(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        this.configurationService.upsert(this.form.getRawValue() as EnergyConsumptionReportConfiguration).subscribe({
            next: () => this.dialogRef.close(true),
            error: () => { }
        });
    }
}